import LocalLanding from "./LocalLanding";
export default function LandingSetubal() {
    return (
        <LocalLanding
            city="Distrito de Setúbal"
            canonicalSlug="remodelacoes-setubal"
            hero="https://images.unsplash.com/photo-1749473241809-d434c004b214?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
        />
    );
}
